export default __webpack_public_path__ + "static/media/design-2.091ee404.svg";